module.exports = __webpack_public_path__ + "img/冷库温度显示装置检定报告.f704c32f.png";